"use client";

import {JSX} from "react";

import {useSnapshot} from "valtio";

import {type GuestsStepperInstance} from "@/features/rental";

import {useTranslation} from "@/shared/i18n";
import {Typography} from "@/shared/ui/data-display/typography";

import "../styles/guests-view.scss";
import "@/shared/ui/form/steppers/styles/stepper-field.scss";

interface PetsToggleProps {
    model: GuestsStepperInstance;
    subtitle?: string;
    className?: string;
}

export function PetsToggle({model, subtitle, className}: PetsToggleProps): JSX.Element {
    const {t} = useTranslation("search");
    const snapshot = useSnapshot(model);

    return (
        <div className={`stepper-field ${className || ""}`}>
            <div className="stepper-field__wrapper">
                <div className="stepper-field__header">
                    <div className="stepper-field__labels">
                        <Typography as="label">{t("petsAllowed")}</Typography>
                        {subtitle && (
                            <Typography as="span" size={12} color="paragraph2">
                                {subtitle}
                            </Typography>
                        )}
                    </div>
                </div>
                <button
                    type="button"
                    role="switch"
                    aria-checked={snapshot.petsEnabled}
                    disabled={snapshot.petsNotAllowed}
                    onClick={() => model.togglePets(!snapshot.petsEnabled)}
                    className={`guests-view__toggle ${snapshot.petsEnabled ? "guests-view__toggle--on" : ""}`}
                >
                    <span className="guests-view__toggle-thumb" />
                </button>
            </div>
        </div>
    );
}
